import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from '../services/keycloak/keycloak.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const keycloakService = inject(KeycloakService);

  // Skip auth for config loading
  if (req.url.includes('/assets/config/')) {
    return next(req);
  }

  // Add token if authenticated
  if (keycloakService.isAuthenticated()) {
    const token = keycloakService.token();
    if (token) {
      const authenticatedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next(authenticatedReq);
    }
  }

  return next(req);
};
